document.addEventListener('change', function(e) {
  const input = e.target;

  // Only trigger on filter checkboxes that are NOT the availability filter
  if (
    input.type !== 'checkbox' ||
    !input.name ||
    !input.name.startsWith('filter.') ||
    input.name === 'filter.v.availability'
  ) return;

  if (input.checked) {
    // Find the availability "in stock" checkbox
    const availabilityCheckbox = document.querySelector(
      'input[name="filter.v.availability"][value="1"]'
    );

    if (availabilityCheckbox && !availabilityCheckbox.checked) {
      availabilityCheckbox.checked = true;
      // Trigger a change event so the theme picks it up
      availabilityCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});